<template>
  <div id="configuratore">
    <el-main class="main-class" ref="canvas">
      <!-- <div style="position: absolute; z-index: 1000;" class="alertQrCode" v-if="!activeModelFromQrCode">
        <div class="alert-container">
          <div class="button" @click="closeAlertQrcode()">
            <svg width="32" height="32" fill="#ff0000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m18.75 6.82-1.57-1.57L12 10.43 6.82 5.25 5.25 6.82 10.43 12l-5.18 5.18 1.57 1.57L12 13.57l5.18 5.18 1.57-1.57L13.57 12l5.18-5.18Z">
              </path>
            </svg>
          </div>
          <div class="text uppercase">
            <p>{{ $t("message.configurazione_non_valida") }}</p>
            <p class="uppercase">
              {{ activeModelText }}
            </p>
          </div>
        </div>
      </div> -->
      <Canvas3d :shouldLoadScene="false" defaultFrontModel="MYC-001" defaultFrontColor="EP0001"
        defaultTemplesColor="PL0001"></Canvas3d>
      <div id="popoverMultistrato">
        <el-popover visible-arrow="false" popper-class="pop-multistrato" trigger="manual" v-model="dialogMultistrato"
          placement="bottom">
          <el-card>
            <div slot="header">
              <span>ANTEPRIMA NON DISPONIBILE</span>
            </div>
            <div class="colore-esterno">
              <span>COLORE ESTERNO</span>
              <el-image v-if="this.$store.state.configurator.colore" :src="'https://cdn.thema-optical.com/3d-models/colori_acetato_sito/' +
                this.$store.state.configurator.colore.U_THE_COLORE +
                '.jpg'
                " fit="scale-down"></el-image>
            </div>
            <div class="colore-interno">
              <span>COLORE INTERNO</span>
              <el-image v-if="this.$store.state.configurator.colore" :src="'https://cdn.thema-optical.com/3d-models/colori_acetato_sito/' +
                this.$store.state.configurator.colore.U_THE_COLORE +
                '_b.jpg'
                " fit="scale-down"></el-image>
            </div>
          </el-card>
        </el-popover>
      </div>

      <!-- <Canvas
        :setCanvasPos="setCanvasPos"
        :resetMaterial="resetMaterial"
        @settedPosition="setCanvasPos = false"
      />-->
    </el-main>
    <footer class="footer-class" :class="{ close: menuClosed }" ref="menu">
      <Menu @setPositionForPrint="setCanvasPos = true" @resettedMaterial="resetForMaterial" @close="closeMenu()"
        @open="openMenu()" />
    </footer>
  </div>
</template>

<script>
import componenti from "../components/configuratore";

export default {
  name: "Configuratore",
  components: componenti,
  data() {
    return {
      resetMaterial: false,
      menuClosed: false,
      showHeader: true,
      setCanvasPos: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  methods: {
    mounted() {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("show-header")) {
        this.showHeader = urlParams.get("show-header") != "false";
      }
      this.dialogMultistrato = false;
    },
    resetForMaterial() {
      this.resetMaterial = true;
      setTimeout(() => {
        this.resetMaterial = false;
      }, 3000);
    },
    closeMenu() {
      let canvas = this.$refs.canvas;
      // canvas.$el.style.maxWidth = "100vh";
      // canvas.$el.style.width = "100vh";

      if (this.windowWidth < 768) {
        canvas.$el.style.maxHeight = "94vh";
        canvas.$el.style.height = "calc(100% - 55px)";
        // canvas.$el.style.maxHeight = window.innerHeight;
        // canvas.$el.style.height = `calc(${window.innerHeight} - 55px)`;
        // canvas.$el.style.marginTop = "25vh";
        // canvas.$el.style.marginBottom = "25vh";
        // canvas.$el.style.position = "relative";
        // canvas.$el.style.bottom = "0";
        // console.log("CANVAS", canvas);
      } else {
        canvas.$el.style.maxHeight = "100vh";
        canvas.$el.style.height = "100vh";
      }
      setTimeout(() => {
        // console.log(canvas.$children[0]);
        canvas.$children[0].onContainerResize();
      }, 600);
    },
    closeAlertQrcode() {
      this.activeModelFromQrCode = true;
    },
    openMenu() {
      let canvas = this.$refs.canvas;

      // canvas.$el.style.maxHeight = "60vh";
      // canvas.$el.style.height = "60vh";

      if (this.windowWidth < 768) {
        canvas.$el.style.maxHeight = "0vh";
        canvas.$el.style.height = "0vh";
        canvas.$el.style.marginTop = "0vh";
        canvas.$el.style.marginBottom = "0vh";
      } else {
        canvas.$el.style.maxHeight = "60vh";
        canvas.$el.style.height = "60vh";
      }


      setTimeout(() => {
        canvas.$children[0].onContainerResize();
      }, 600);
    },
  },

  computed: {
    dialogMultistrato : {
      get() {
        if (
          this.$store.state.configurator.colore &&
          this.$store.state.configurator.colore.Category == "MULTISTRATO"
        ) {
          return true;
        } else {
          return false;
        }
      },
      set(v) {
        console.log("SET DIALOG MULTISTRATO", v);
      }
    },
    activeModelText() {
      let phrase = "";
      if (!this.frontalModelQrCode) {
        phrase = this.$t("message.il_modello_non_è_piu_disponibile").toString();
      }
      if (!this.frontalColorQrCode) {
        phrase = this.$t("message.il_colore_non_è_più_disponibile").toString();
      }
      if (!this.frontalTemplesColorQrCode) {
        phrase = this.$t("message.le_aste_non_sono_più_disponibili").toString();
      }
      return phrase;
    },
    frontalTemplesColorQrCode() {
      return this.$store.state.configurator.templeQrCode;
    },
    frontalColorQrCode() {
      return this.$store.state.configurator.colorQrCode;
    },
    frontalModelQrCode() {
      return this.$store.state.configurator.frontalQrCode;
    },
    activeModelFromQrCode: {
      get() {
        return this.$store.state.configurator.activeModelFromQrCode;
      },
      set(v) {
        this.$store.state.configurator.activeModelFromQrCode = v;
      }
    }
  },
};
</script>

<style lang="less">
.uppercase {
  text-transform: uppercase;
}

// @menu-height: 40vh;

// @media (max-width: 767px) {
//   .main-class {
//     max-height: 91vh !important;
//     height: 50vh !important;
//     // margin-top: 25% !important;
//     // margin-bottom: 25% !important;
//   }
// }

// @media (min-width: 768px) {
//   .main-class {
//     max-height: 60vh;
//     height: 60vh;
//   }
// }
.main-class {
  width: 100vw;
  max-height: 60vh;
  height: 60vh;
  padding: 0px !important;
  // margin: 0px !important;
  overflow: hidden;
  position: relative;
  transition-duration: 0.4s;
}

.alertQrCode {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  .alert-container {
    position: relative;
    background-color: rgba(22, 22, 21, 0.8);
    padding: 20px;
    font-size: 20px;
    text-align: center;
    margin: 0;
    width: 40%;

    .button {
      cursor: pointer;
      position: absolute;
      top: 2%;
      right: 2%;
    }
  }
}

@media (max-width: 767px) {
  .footer-class {
    height: 0vh !important;
    max-height: 0vh !important;
  }
}

@media (min-width: 768px) {
  .footer-class {
    height: 40vh;
    max-height: 40vh !important;
  }
}

.footer-class {
  width: 100%;
  height: 40vh;
  max-height: 40vh !important;
  min-height: 200px;
  padding: 0px !important;
  // border-top: solid @--color-primary 3px;

  transition-duration: 0.5s;

  // &.close {
  //   transform: translateY(40vh);
  // }
}
</style>